module.exports = __webpack_public_path__ + "img/undraw_fixing_bugs.b38b0760.svg";